import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import AppStore from '../../store/appStore';
import { errorLayout as ErrorLayout } from 'helper/layout-helper';
import { withRouter } from 'react-router';

@withRouter
class AppErrorContainer extends Component {

  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
    error: PropTypes.object,
    location: PropTypes.object
  };

  static defaultProps = {

  };

  get shouldHideCode() {
    const errorCode = get(this.state, 'error.errorCode');
    return errorCode === 404 || errorCode === 500 || errorCode === 503;
  }

  constructor(props) {
    super(props);
    this.state = {
      error: AppStore.getAppError()
    };
  }

  componentWillMount(){
    AppStore.addErrorListener(this._onError);
  }

  componentWillUnmount(){
    AppStore.removeErrorListener(this._onError);
    AppStore.cleanAppErrorState();
  }

  componentWillReceiveProps(nextProps){
    if (nextProps.error) {
      this.setState({ error: nextProps.error })
    } else if (nextProps.location.key !== this.props.location.key && this.state.error) {
      this.setState({
        error: null
      });
    }
  }

  render() {
    const { children } = this.props;
    const { error } = this.state;

    if (error) {
      return (<ErrorLayout hideCode={this.shouldHideCode} error={this.state.error}/>)
    }

    return (children);
  }

  _onError = () => {
    this.setState({
      error: AppStore.getAppError()
    });
  }

}

export default AppErrorContainer;
